<template>
  <div class="informations-wrapper" v-if="!isUserPending">
    <div class="container">
      <div class="card card-form">
        <div class="card-section">
          <h3>{{ $t("app.profil.informations.editPersonal") }}</h3>
          <VForm :callback="() => {}">
            <template #form-body>
              <div class="input-inline">
                <VField name="profil-firstname" rules="required|textOnly" v-model="user.personal_information.first_name" :label="$t('app.form.register.firstName')" :disabled="true" />
                <VField name="profil-lastname" rules="required|textOnly" v-model="user.personal_information.last_name" :label="$t('app.form.register.lastName')" :disabled="true" />
              </div>
              <div class="input-inline">
                <VField type="email" name="profil-mail" rules="required|email" v-model="user.personal_information.email" :label="$t('app.form.email')" :disabled="true" />
              </div>
            </template>
          </VForm>
        </div>
      </div>
      <div class="side-col">
        <div class="card card-picture">
          <h3>{{ $t("app.profil.informations.profilePicture") }}</h3>
          <div class="header-block">
            <img class="picture" :src="user.personal_information.profile_picture_id ? getImage(user.personal_information.profile_picture_id) : getRandomUserPicture(user.personal_information.first_name)" alt="picture" />
            <div class="block">
              <h4>{{ $t("app.profil.informations.changePicture") }}</h4>
            </div>
          </div>
          <Dropload v-model="image" @update:modelValue="(event) => setImage(event)" />
        </div>
        <div class="card delete-account">
          <h3>{{ $t("app.profil.informations.deleteAccount") }}</h3>
          <i18n-t keypath="app.profil.informations.deleteAccountDesc1" tag="p">
            <template #link>
              <span class="virtual-link" @click="crisp.chat.open()"> {{ $t("app.profil.informations.customerService") }} </span>
            </template>
          </i18n-t>
          <p class="muted">
            {{ $t("app.profil.informations.deleteAccountDesc2") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, inject } from "vue";
import { getImage, getRandomUserPicture } from "@/composables/getImage.js";

import { useImageStore } from "@/stores/image.js";
import { useToast } from "vue-toastification";

import { useOrganisation } from "@/queries/organisation.query";
import { useUpdateProfilePicture, useUser } from "@/queries/user.query";

const toast = useToast();
const { t } = useI18n();

const crisp = inject("crisp");

const { uploadImage } = useImageStore();

const { mutate: updateUserProfilePicture } = useUpdateProfilePicture();

const { data: user, isPending: isUserPending } = useUser();
const { data: organisation, isPending: isOrganisationPending } = useOrganisation();

const image = ref(null);

const state = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  loading: false,
});

async function setImage(value) {
  state.loading = true;

  const { image_id } = await uploadImage(organisation.value.id, "user_profile_picture", value);

  if (image_id) {
    updateUserProfilePicture(image_id);
  } else {
    toast.error(t("app.profil.informations.imageUploadError"));
  }

  state.loading = false;
}
</script>
